<template>
  <div class="container">
      <el-form :model="inputForm" ref="inputForm" @submit.native.prevent class="el-form search-form" :class="{rightBorder: searchTabActive!=='Blending'}">
        <el-row>
          <el-col :span="12" style="padding-right: 40px;">
            <el-form-item prop="userInputModelName">
              <el-autocomplete
                class="inline-input userInputPJName"
                v-model="inputForm.userInputModelName"
                :fetch-suggestions="querySearch"
                :placeholder="$t('T_MODEL_SEARCH_TIPS')"
                :trigger-on-focus="false"
                @select="setSelectedPJModel"
                clearable
                @keyup.enter.native="onModelSearch"
                style="width: 100%"
              >
                <el-button slot="append" :class="{searchIcon:!isPress, searchIconPress: isPress}"
                  @mousedown.native="isPress = true" @click="onModelSearch"  @mouseup.native="isPress = false">
                </el-button>
                <template slot-scope="{ item }">
                  <span>{{ getModelLabel(item.value) }}</span>
                </template>
              </el-autocomplete>
            </el-form-item>
          </el-col>
            <el-form-item :label="$t('T_SEARCH_RESULT') + ':'" class="search-result-item">
              <span>{{ matchingModelData.length }}</span>
              <span v-if="matchingModelData.length === 1 || matchingModelData.length === 0">{{$t('T_RESULT')}}</span>
              <span v-else>{{$t('T_RESULTS')}}</span>
            </el-form-item>
            <el-form-item>
              <el-select style="width: 260px;" v-model="inputForm.selectedModel" @change="onModelChange">
                <el-option v-for="item in matchingModelDataSort" :key="item.value" :value="item.name" :label="getModelLabel(item.name)" />
              </el-select>
            </el-form-item>
        </el-row>
      </el-form>
  </div>
</template>

<script>
// import ProjectorSpec from '@/assets/data/projectorSpec.json'
import { mapState, mapMutations } from 'vuex'
import { gaEvent } from '../../../common/ga'// GA追加

export default {
  name: 'searchProjectorTab',
  data () {
    return {
      inputForm: {
        userInputModelName: '',
        selectedModel: this.$store.state.selectedModelData.name
      },
      userInput: '',
      isPress: false,
      selectOptions: [],
      selectedModelIndex: 0
    }
  },
  computed: {
    ...mapState([
      'searchMatchingModelData', 'searchSelectedModelData', 'searchMatchingLensID', 'searchSelectedLensData', 'matchingModelData', 'selectedModelData', 'searchTabActive', 'isSimple',
      'position', 'searchTabActive', 'fromBlending'
    ]),

    matchingModelDataSort () {
      return this.$commonJs.dataSort(this.matchingModelData, 'name')
    }
  },
  watch: {
    searchTabActive (val) {
      // 曲面的场合，执行searchProjectorTabByCurved.vue 里面 searchTabActive 的监听，不执行下面代码
      // if ((val === 'Search' || val === 'CurvedSurface') && !this.fromBlending) {
      if ((val === 'Search') && !this.fromBlending) {
        this.MATCHINGMODELDATA(this.searchMatchingModelData)
        this.SELECTEDMODELDATA(this.searchSelectedModelData)
        if (this.inputForm.userInputModelName && this.searchSelectedModelData.name !== this.inputForm.userInputModelName) {
          this.onModelSearch()
        }
        this.MATCHINGLENSID(this.searchMatchingLensID)
        this.SELECTEDLENSDATA(this.searchSelectedLensData)
        if (!this.inputForm.userInputModelName && this.searchSelectedModelData) {
          // 检索框里面没有内容的场合，从 CurvedSurface -> Search 切换，镜头信息需要重新设置
          let lensInfo = this.$commonJs.findLensInfo(this.searchSelectedModelData)
          this.setLensData(lensInfo.matchingLensID, lensInfo.selectedLensInfo)
        }
      }
    },

    selectedModelData (val, oldVal) {
      this.inputForm.selectedModel = val.name
      // GA追加：検索結果的モデル变化触发
      sessionStorage.setItem('LENSES', '') // 避免前一次有镜头的值，所以每次清空，重新设定
      sessionStorage.setItem('m_model_name', this.getModelLabel(val.name))
      // 只有在「型番検索」，「曲面スクリーン」和「エッジブレンディング」这3个tab下才有模糊检索的入力框，其他的tab都做清空处理
      if (this.searchTabActive !== 'Search' && this.searchTabActive !== 'CurvedSurface' && this.searchTabActive !== 'Blending') {
        sessionStorage.setItem('search_m_model', '')
      }
      // console.log('XXXXX:', this.$store.state.bmSelectedLensData.name)
      // selectedLensData,  selectedModelData,  matchingLensID(Array)=lensList(Array),
      // 避免多次发送数据。因为在镜头选择的时候也会发送，所以在有镜头数据时，镜头选择处发送数据，没有镜头数据这里发送数据
      if (val.name === this.$store.state.selectedModelData.name && !this.$store.state.selectedLensData.name) {
        gaEvent({action: 'T_MAINTENANCE_MODEL_NAME'})
      }
      // GA追加：検索結果的モデル变化触发
    }
  },
  created () {
    let lensData = this.findMatchingLensAndSelectedLensData(this.searchMatchingModelData)
    this.setSpecificInfo(lensData)
  },
  methods: {
    ...mapMutations([
      'F_S2D',
      'F_D2S',
      'F_VOFFSET',
      'VLENSSHIFT',
      'HLENSSHIFT',
      'VHLENSSHIFT',
      'ASPECTRATIO',
      'SEARCHMATCHINGMODELDATA', 'SEARCHSELECTEDMODELDATA', 'SEARCHMATCHINGLENSID', 'SEARCHSELECTEDLENSDATA',
      'SET_VLENSSHIFT', 'SET_HLENSSHIFT', 'SET_OFFSET',
      'SET_HANGLEFLAG', 'SET_VANGLEFLAG', 'SET_SCREENSIZECHECKED', 'SET_THROWDISTANCECHECKED', 'SET_REALTHROWDISTANCECHECKED', 'ROOMW', 'ROOMD', 'ROOMH',
      'MATCHINGMODELDATA', 'SELECTEDMODELDATA', 'MATCHINGLENSID', 'SELECTEDLENSDATA', 'SET_TEMVLENSSHIFT', 'SET_ISSIMPLE', 'SET_POSITION', 'SET_TABACTIVENAME',
      'SET_ISUSTWALL',
      'SET_OUTOFSPECVAL',
      'SET_ISOUTOFSPEC',
      'SET_WHITEBOARDSTATUS'
    ]),

    querySearch (queryString, cb) {
      var results = queryString ? this.ProjectorSpec.filter(this.createFilter(queryString)) : this.ProjectorSpec
      // 调用 callback 返回建议列表的数据
      results.sort((obj1, obj2) => {
        return obj1.name.localeCompare(obj2.name)
      })
      cb(results)
    },

    createFilter (queryString) {
      return (dataOptions) => {
        dataOptions.value = dataOptions.name
        let label = this.getModelLabel(dataOptions.name)
        return (label.toLowerCase().indexOf(queryString.toLowerCase()) > -1)
      }
    },
    setSelectedPJModel (value) {
      // GA追加：入力框检索（选择之后触发）this.$t('T_SEARCH_MODEL')
      sessionStorage.setItem('search_m_model', this.getModelLabel(this.inputForm.userInputModelName))
      // GA追加：入力框检索（选择之后触发）
      this.selectedModelIndex = 0
      this.SEARCHMATCHINGMODELDATA([value])
      this.SEARCHSELECTEDMODELDATA(value)
      this.MATCHINGMODELDATA([value])
      this.SELECTEDMODELDATA(value)
      this.findMatchingLensAndSelectedLensData([value])
      this.SET_WHITEBOARDSTATUS(false)
      this.inputForm.userInputModelName = this.getModelLabel(this.inputForm.userInputModelName)
      // 统一到simpleViewIndex.vue中处理
      // if (this.isSimple && (value.category === 4 || value.category === 5) && value.position === 2) {
      //   this.$commonJs.SimpleDisable()
      //   this.$router.push('/page/advanceMode')
      //   this.SET_ISSIMPLE(false)
      //   this.SET_TABACTIVENAME('Advanced')
      //   this.SET_POSITION(2)
      // }
    },
    onModelSearch (event) {
      // GA追加：入力框检索（按下回车或点放大镜触发）this.$t('T_SEARCH_MODEL')
      sessionStorage.setItem('search_m_model', this.inputForm.userInputModelName)
      // GA追加：入力框检索（按下回车或点放大镜触发）
      this.findMatchingModel()
      this.userInput = this.inputForm.userInputModelName
      this.SET_WHITEBOARDSTATUS(false)
      // 统一到simpleViewIndex.vue中处理
      // if (this.isSimple && (this.selectedModelData.category === 4 || this.selectedModelData.category === 5) && this.position === 2) {
      //   this.$commonJs.SimpleDisable()
      //   this.$router.push('/page/advanceMode')
      //   this.SET_ISSIMPLE(false)
      //   this.SET_TABACTIVENAME('Advanced')
      //   this.SET_POSITION(2)
      // }
    },
    findMatchingModel () {
      let matchModelArr = []
      let userInputModelName = this.inputForm.userInputModelName.toLowerCase()
      let isSame = false
      this.selectedModelIndex = 0
      this.ProjectorSpec.filter(item => {
        let pjName = this.getModelLabel(item.name).toLowerCase()
        if (pjName.indexOf(userInputModelName) !== -1) {
          matchModelArr.push(item)
        }
        if (pjName === userInputModelName) {
          isSame = true
        }
      })
      matchModelArr = this.$commonJs.dataSort(matchModelArr, 'name')
      if (isSame) {
        this.selectedModelIndex = matchModelArr.findIndex((item) => this.getModelLabel(item.name).toLowerCase() === userInputModelName)
      }
      if (matchModelArr.length > 0) {
        this.setModeldata(matchModelArr)
        this.findMatchingLensAndSelectedLensData(matchModelArr)
      } else {
        if (document.getElementsByClassName('el-message').length === 0) {
          this.$message.warning({
            message: this.$t('T_NO_RESULT'),
            duration: 3000
          })
        }
      }
    },
    setModeldata (value) {
      this.SEARCHMATCHINGMODELDATA(value)
      this.SEARCHSELECTEDMODELDATA(value[this.selectedModelIndex])
      this.MATCHINGMODELDATA(value)
      this.SELECTEDMODELDATA(value[this.selectedModelIndex])
    },
    setLensData (idArr, data) {
      this.SEARCHMATCHINGLENSID(idArr)
      this.SEARCHSELECTEDLENSDATA(data)
      this.MATCHINGLENSID(idArr)
      this.SELECTEDLENSDATA(data)
    },
    findMatchingLensAndSelectedLensData (modelArr) {
      let selectedModelData = modelArr[this.selectedModelIndex]
      let lensInfo = this.$commonJs.findLensInfo(selectedModelData)
      this.setLensData(lensInfo.matchingLensID, lensInfo.selectedLensInfo)
      return lensInfo.selectedLensInfo
    },
    setSpecificInfo (data) {
      let defaultRatio = data.lcd.aspectRatio
      let defaultDistInfo = data.lcd.distInfo.find(
        item => item.ratio === defaultRatio
      )
      this.F_S2D(defaultDistInfo.size2dist)
      this.F_D2S(defaultDistInfo.dist2size)
      this.F_VOFFSET(defaultDistInfo.screenSizeToVOffset)

      this.VLENSSHIFT(data.lcd.lensShiftRange.v)
      this.SET_TEMVLENSSHIFT(data.lcd.lensShiftRange.v)
      this.HLENSSHIFT(data.lcd.lensShiftRange.h)
      this.VHLENSSHIFT(data.lcd.lensShiftRange.hv)
      this.ASPECTRATIO(data.lcd.aspectRatio)
    },

    // 投影仪切换
    onModelChange (value) {
      this.setSelectedModelData(value)
      this.findMatchingLensAndSelectedLensData([this.selectedModelData])
    },

    setSelectedModelData (value) {
      let selectedModelData = this.matchingModelData.find(
        item => item.name === value
      )
      this.SELECTEDMODELDATA(selectedModelData)
      this.SEARCHSELECTEDMODELDATA(selectedModelData)
    },
    getModelLabel (label) {
      return this.$commonJs.getModelLabelByName(label)
    }
  }

}
</script>

<style scoped>
.searchIcon {
  background: url('~@/assets/parts/icon/TDC_search.png') no-repeat center;
}

.searchIconPress {
  background: url('~@/assets/parts/icon/TDC_search.png') no-repeat center;
}
.rightBorder{
  border-right: 2px solid #bdbdbd;
}
</style>



// WEBPACK FOOTER //
// src/view/searchTabs/tabs/searchProjectorTab.vue